import React, { useState } from 'react';
import { Modal } from 'antd';
import message from '@web-common/components/UI/Message/SiriusMessage';
import { apiHolder, apis } from 'api';
import Search from '@/images/empty/search.png';
import style from './mailDiscussPopover.module.scss';
import DiscussIntro from '@web-common/components/UI/DiscussIntro/discussIntro';
import IconCard from '@web-common/components/UI/IconCard';
import { openSession } from '@web-im/common/navigate';
import { MailActions } from '@web-common/state/reducer';
import { useActions } from '@web-common/state/createStore';
import { getIn18Text } from 'api';
const trackApi = apiHolder.api.requireLogicalApi(apis.dataTrackerApiImp);
const nimApi = apiHolder.api.requireLogicalApi('NIM');
const MailDiscussPopover = props => {
    const { teamMsgs, teamCount, mailMid, closePopover, noWrap } = props;
    const mailActions = useActions(MailActions);
    const [discussIntroVis, setDiscussIntroVis] = useState(false);
    const ckWhatsDiscuss = () => {
        if (!nimApi.getIMAuthConfig()) {
            message.info('消息模块已被关闭，请联系企业管理员！');
            return;
        }
        trackApi.track('pcmail_click_mailDetail_mailChatList_mailChatIntroduce', {});
        setDiscussIntroVis(true);
    };
    const close = () => setDiscussIntroVis(false);
    const discussIntroFun = () => React.createElement(DiscussIntro, { close: close, mailMid: mailMid });
    const checkDiscuss = (discuss) => {
        trackApi.track('pcmail_click_mailDetail_mailChatList_goToMailChat', {});
        if (!nimApi.getIMAuthConfig()) {
            message.info(getIn18Text('XIAOXIMOKUAIYI'));
            return;
        }
        openSession({
            sessionId: `team-${discuss.teamId}`,
            mode: 'normal',
        }, {
            createSession: true,
        });
        closePopover && closePopover();
    };
    const createDiscuss = () => {
        trackApi.track('pcmail_click_mailDetail_mailChatList_addNewEmailChat', {});
        if (!nimApi.getIMAuthConfig()) {
            message.info(getIn18Text('XIAOXIMOKUAIYI'));
            return;
        }
        mailActions.doUpdateShareMailMid(mailMid);
        closePopover && closePopover();
    };
    return (React.createElement("div", { className: noWrap ? style.mailDiscussNoWrap : style.mailDiscuss, onClick: e => e.stopPropagation() },
        React.createElement("div", { className: style.header },
            teamCount && teamCount > 0 ? `已关联${teamCount}个邮件讨论` : getIn18Text('YOUJIANTAOLUN'),
            React.createElement("span", { className: style.whatsDiscuss, onClick: ckWhatsDiscuss }, getIn18Text('SHENMESHIYOUJIAN'))),
        React.createElement("div", { className: style.content },
            teamCount > 0 && (React.createElement("div", { className: style.hasDiscuss },
                teamMsgs.ownTeams.length > 0 && (React.createElement("div", { className: style.startByMe },
                    React.createElement("p", { className: style.discussTyTitle }, getIn18Text('WOFAQIDEYOU')),
                    teamMsgs.ownTeams.map((item, _) => (React.createElement("div", { className: style.discussItem, onClick: () => checkDiscuss(item) },
                        React.createElement("img", { className: style.discussIcon, src: item.icon }),
                        React.createElement("span", { className: style.discussTitle }, item.teamName),
                        React.createElement("div", { className: style.right },
                            React.createElement(IconCard, { type: "arrowRight" }))))))),
                teamMsgs.joinTeams.length > 0 && (React.createElement("div", { className: style.join },
                    React.createElement("p", { className: style.discussTyTitle }, getIn18Text('WOJIARUDEYOU')),
                    teamMsgs.joinTeams.map((item, _) => (React.createElement("div", { className: style.discussItem, onClick: () => checkDiscuss(item) },
                        React.createElement("img", { className: style.discussIcon, src: item.icon }),
                        React.createElement("span", { className: style.discussTitle }, item.teamName),
                        React.createElement("div", { className: style.right },
                            React.createElement(IconCard, { type: "arrowRight" }))))))))),
            teamCount === 0 && (React.createElement("div", { className: style.noDiscuss },
                React.createElement("img", { style: { width: 130, height: 130, margin: '24px auto 0 auto', display: 'block' }, src: Search, alt: "" }),
                React.createElement("p", { className: style.noDiscussYet }, getIn18Text('GAIYOUJIANWEIFA'))))),
        React.createElement("div", { className: style.footer },
            React.createElement("button", { className: style.startDiscuss, onClick: createDiscuss }, getIn18Text('QUFAQIYOUJIAN'))),
        React.createElement(Modal, { modalRender: discussIntroFun, wrapClassName: "discuss-intro-wrap", centered: true, visible: discussIntroVis, maskStyle: { left: '68px', zIndex: 1090 }, destroyOnClose: true })));
};
export default MailDiscussPopover;
